export default __webpack_public_path__ + "static/media/balsamiq.85288597.jpeg";